import React from 'react';
import { Badge } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { statusMeta } from '../logic';
import { ReviewStatus } from '../types';

type Props = {
  status: ReviewStatus;
};

export const CompensationReviewStatusBadge: React.FC<
  React.PropsWithChildren<Props>
> = ({ status }) => {
  const t = useNamespacedTranslation('compensationReviews.status');
  const { variant, labelKey } = statusMeta(status);

  return (
    <Badge bg={variant} className="text-uppercase">
      {t(labelKey)}
    </Badge>
  );
};
